import React, { useState, useEffect } from 'react';
import { Settings as SettingsIcon, Save, Key, Building, FileImage } from 'lucide-react';

interface SettingsProps {
  onClose: () => void;
  onSave: (apiKey: string, companyInfo: any) => void;
}

const Settings: React.FC<SettingsProps> = ({ onClose, onSave }) => {
  const [apiKey, setApiKey] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyAddress, setCompanyAddress] = useState('');
  const [companyEmail, setCompanyEmail] = useState('');
  const [companyPhone, setCompanyPhone] = useState('');
  const [companySiret, setCompanySiret] = useState('');
  const [logoPreview, setLogoPreview] = useState<string>('');

  useEffect(() => {
    // Charger les données sauvegardées
    const savedApiKey = localStorage.getItem('hospitableApiKey') || '';
    const savedCompanyInfo = localStorage.getItem('companyInfo');
    
    setApiKey(savedApiKey);
    
    if (savedCompanyInfo) {
      const info = JSON.parse(savedCompanyInfo);
      setCompanyName(info.name || '');
      setCompanyAddress(info.address || '');
      setCompanyEmail(info.email || '');
      setCompanyPhone(info.phone || '');
      setCompanySiret(info.siret || '');
      // Toujours afficher le logo public dans la preview
      setLogoPreview('/logo.png');
    } else {
      // Valeurs par défaut
      setCompanyName('BARRALON Jeremy');
      setCompanySiret('513124610');
      // Utiliser le logo public par défaut
      setLogoPreview('/logo.png');
    }
  }, []);


  const handleSave = () => {
    // Utiliser le logo public par défaut
    const companyInfo = {
      name: companyName,
      address: companyAddress,
      email: companyEmail,
      phone: companyPhone,
      siret: companySiret,
      logoUrl: '/logo.png' // Toujours utiliser le fichier public
    };

    // Sauvegarder dans le localStorage
    localStorage.setItem('hospitableApiKey', apiKey);
    localStorage.setItem('companyInfo', JSON.stringify(companyInfo));

    // Appeler la fonction de sauvegarde
    onSave(apiKey, companyInfo);

    // Afficher un message de succès
    alert('Paramètres sauvegardés avec succès !');
  };

  return (
    <div className="settings-modal">
      <div className="settings-container">
        <div className="settings-header">
          <h2>
            <SettingsIcon size={24} />
            Paramètres
          </h2>
          <button onClick={onClose} className="close-button">×</button>
        </div>

        <div className="settings-content">
          {/* Section API */}
          <div className="settings-section">
            <h3>
              <Key size={20} />
              Configuration API
            </h3>
            <div className="form-group">
              <label htmlFor="apiKey">Clé API Hospitable</label>
              <input
                type="password"
                id="apiKey"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="Entrez votre clé API..."
              />
              <small>Obtenez votre clé API depuis votre compte Hospitable</small>
            </div>
          </div>

          {/* Section Informations de facturation */}
          <div className="settings-section">
            <h3>
              <Building size={20} />
              Informations de facturation
            </h3>
            
            <div className="form-group">
              <label htmlFor="companyName">Nom de l'entreprise</label>
              <input
                type="text"
                id="companyName"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                placeholder="Nom de votre entreprise"
              />
            </div>

            <div className="form-group">
              <label htmlFor="companyAddress">Adresse</label>
              <textarea
                id="companyAddress"
                value={companyAddress}
                onChange={(e) => setCompanyAddress(e.target.value)}
                placeholder="Adresse complète"
                rows={3}
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="companyEmail">Email</label>
                <input
                  type="email"
                  id="companyEmail"
                  value={companyEmail}
                  onChange={(e) => setCompanyEmail(e.target.value)}
                  placeholder="email@example.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="companyPhone">Téléphone</label>
                <input
                  type="tel"
                  id="companyPhone"
                  value={companyPhone}
                  onChange={(e) => setCompanyPhone(e.target.value)}
                  placeholder="06 00 00 00 00"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="companySiret">SIRET</label>
              <input
                type="text"
                id="companySiret"
                value={companySiret}
                onChange={(e) => setCompanySiret(e.target.value)}
                placeholder="Numéro SIRET"
              />
            </div>

            <div className="form-group">
              <label>
                <FileImage size={20} />
                Logo de l'entreprise
              </label>
              {logoPreview && (
                <div className="logo-preview">
                  <img src={logoPreview} alt="Logo de l'entreprise" />
                  <small style={{ color: '#666', marginTop: '8px', display: 'block' }}>
                    Le logo est chargé depuis le fichier public/logo.png
                  </small>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="settings-footer">
          <button onClick={onClose} className="secondary-button">
            Annuler
          </button>
          <button onClick={handleSave} className="primary-button">
            <Save size={20} />
            Sauvegarder
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;